export const ORDER_PAGE_SIZE = 30;

export function filterOrders(orders, searchTerm) {
  const query = String(searchTerm || '').trim().toLowerCase();
  if (!query) return orders;

  return (orders || []).filter((order) =>
    [
      order.order_id,
      order.order_ref,
      order.order_group_ref,
      order.customer_name,
      order.contact_number,
      order.racquet_brand,
      order.racquet_model,
      order.string_brand,
      order.string_model,
      order.color,
      order.tension,
      order.status,
    ]
      .filter((value) => value !== null && value !== undefined && value !== '')
      .some((value) => String(value).toLowerCase().includes(query))
  );
}

export function paginateOrders(orders, page, pageSize = ORDER_PAGE_SIZE) {
  const safePageSize = Math.max(1, pageSize);
  const totalItems = (orders || []).length;
  const totalPages = Math.max(1, Math.ceil(totalItems / safePageSize));
  const currentPage = Math.min(Math.max(1, page || 1), totalPages);
  const start = (currentPage - 1) * safePageSize;

  return {
    items: (orders || []).slice(start, start + safePageSize),
    currentPage,
    totalPages,
    totalItems,
  };
}
